// ** React Imports
import { Fragment } from 'react'

// ** Third Party Components
import { ArrowLeft } from 'react-feather'
import { useForm, Controller } from 'react-hook-form'
import IconButton from '@mui/material/IconButton'
import { Icon } from '@iconify/react'
import Typography from '@mui/material/Typography'
import { Label, Row, Col, Button, Form, Input, FormFeedback } from 'reactstrap'
import { useOnboarding } from '../OnboardingContext'
import FileWorker from './FileWorker'
import LinearProgress from '@mui/material/LinearProgress'
import { useTranslation } from 'react-i18next'

const defaultValues = {
  documentation: 'https://wiki.optimahr.app',
  support: 'https://support.optimahr.app',
  learn: 'https://learn.optimahr.app'
}

const Stuff = ({ stepper }) => {

  const { finishOnboarding, files, filesCurrentAction, ready, setReady, registerCompany, registerSelfUser, registerCollaborators, latestStep } = useOnboarding()
  const { t } = useTranslation()

  // ** Hooks
  const {
    handleSubmit
  } = useForm()

  const onSubmit = () => {
    document.location.href = "/login"
  }

  if (filesCurrentAction !== 'done' && filesCurrentAction !== 'skipped') {
    return (
      <Fragment>
        <div className='content-header'>
          <h5 className='mb-0'>{t('welcome-title')}</h5>
          <small>{t('welcome-subtitle')}</small>
        </div>
        <FileWorker readonly/>
      </Fragment>
    )
  }

  if ((filesCurrentAction === 'done' || filesCurrentAction === 'skipped') && !ready && latestStep === 5) {
    registerCompany().then(() => {
      registerSelfUser().then(
        () => registerCollaborators().then(
          () => {
            setReady(true)
            finishOnboarding()
          }
        )
      )
    })

    return (
      <Fragment>
        <div className='content-header'>
          <h5 className='mb-0'>{t('account-creation')}</h5>
          <small>{t('wait-for-account-creation')}</small>
        </div>
        <LinearProgress />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className='content-header'>
        <h5 className='mb-0'>
        {filesCurrentAction !== 'skipped' &&
          <p>{t('loaded-DSN')} {files.filter(f => f.status === "Done").length}/{files.length}</p>
        }
        </h5>
        <h5 className='mb-0'>{t('useful-links')}</h5>
        <small>{t('useful-links-desc')}</small>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md='6' className='mb-1'>
            <Label className='form-label' for='app'>
            {t('app')}
            </Label>
            <p>https://{document.location.host} <IconButton size='small' onClick={() => { navigator.clipboard.writeText(defaultValues.app) }}><Icon icon='tabler:copy' color='primary' /> </IconButton></p>
          </Col>
          <Col md='6' className='mb-1'>
            <Label className='form-label' for='learn'>
            {t('learn')}
            </Label>
            <p>{defaultValues.learn} <IconButton size='small' onClick={() => { navigator.clipboard.writeText(defaultValues.learn) }}><Icon icon='tabler:copy' color='primary' /> </IconButton></p>
          </Col>
          <Col md='6' className='mb-1'>
            <Label className='form-label' for='documentation'>
            {t('documentation')}
            </Label>
            <p>{defaultValues.documentation} <IconButton size='small' onClick={() => { navigator.clipboard.writeText(defaultValues.documentation) }}><Icon icon='tabler:copy' color='primary' /> </IconButton></p>
          </Col>
          <Col md='6' className='mb-1'>
            <Label className='form-label' for='support'>
            {t('support')}
            </Label>
            <p>{defaultValues.support} <IconButton size='small' onClick={() => { navigator.clipboard.writeText(defaultValues.support) }}><Icon icon='tabler:copy' color='primary' /> </IconButton></p>
          </Col>
        </Row>
        <Row>
          <Col md='7'></Col>
          <Col md='5' style={{display:'flex', justifyContent:'right', alignItems: 'center'}}></Col>
        </Row>
        <div className='d-flex justify-content-between'>
          <Button color='primary' className='btn-prev' onClick={() => stepper.previous()}>
            <ArrowLeft size={14} className='align-middle me-sm-25 me-0'></ArrowLeft>
            <span className='align-middle d-sm-inline-block d-none'>{t('previous')}</span>
          </Button>
          <div>
            <img src="assets/ozp-trans-logo-medium.png" style={{width:"40px"}}/>
            <Typography variant='caption' sx={{ mb: 1, color: 'primary' }} fontSize='15px'>{t('thank-you')}</Typography>
          </div>
            <Button type='submit' color='success' className='btn-submit'>
            {t('start-experience')}
            </Button>
        </div>
      </Form>
    </Fragment>
  )
}

export default Stuff
